export default __webpack_public_path__ + "static/media/sc1.3f28670c.mp4";